import { render, staticRenderFns } from "./MedicalFileInfo.vue?vue&type=template&id=a2c41b9c&scoped=true&"
import script from "./MedicalFileInfo.vue?vue&type=script&lang=js&"
export * from "./MedicalFileInfo.vue?vue&type=script&lang=js&"
import style0 from "./MedicalFileInfo.vue?vue&type=style&index=0&id=a2c41b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c41b9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VExpandTransition,VIcon,VImg,VListItem,VListItemAction,VListItemAvatar,VListItemContent})
